import React, { useCallback, useEffect, useState } from 'react';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import {
  MdModeEdit,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdSearch,
  MdArrowDropDown,
  MdErrorOutline,
  MdArrowDropUp,
} from 'react-icons/md';

import { GoDesktopDownload, GoPlus } from 'react-icons/go';

import { IoIosLock, IoMdArrowBack } from 'react-icons/io';

import { Link } from 'react-router-dom';

import { Pagination } from 'antd';

import { ClipLoader } from 'react-spinners';

import { useDispatch, useSelector } from 'react-redux';
import * as usersActions from '~/store/modules/users/actions';

import history from '~/services/history';

import { Breadcumbs } from '~/components/Breadcumbs';
import { ButtonBase } from '~/components/Button';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  NoResults,
  BoxContentHeader,
  BoxList,
  BoxPagination,
} from './style';
import { ButtonOrderBy } from '~/components/ButtonOrderBy';

import VALIDATIONS from '~/helpers/validations';
import { toast } from 'react-toastify';
import api from '~/services/api';
import FileSaver from 'file-saver';

const UsuariosDoSistema = () => {
  const dispatch = useDispatch();

  const { token, roles } = useSelector(state => state.auth);

  const ROLE_USER = roles.includes('ROLE_USER');
  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  if (ROLE_USER) history.push('/');

  const { usersData, usersOrderBy, usersSearch, loading } = useSelector(
    state => state.users
  );

  const [directionAsc, setDirectionAsc] = useState(true);

  const { data = [], totalCount = 0 } = usersData;

  const [noResults, setNoResults] = useState(false);

  const [pageCurrent, setPageCurrent] = useState(1);
  const [limit, setLimit] = useState(5);

  const [searchBy, setSearchBy] = useState('');

  const [loadingDownloadUsuarios, setLoadingDownloadUsuarios] = useState(false);

  const formik = useFormik({
    initialValues: {
      search: searchBy || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      search: VALIDATIONS.requiredString,
    }),
    onSubmit: async ({ search }) => {
      sessionStorage.setItem('searchUsers', search);
      filterUsuarios({ search });
    },
  });

  const getUsers = useCallback(
    props => {
      const orderBy = props?.orderBy;
      const search = props?.search || formik?.values?.search;
      const offset = props?.offset;
      const dir = props?.dir;

      if (orderBy) sessionStorage.setItem('usersOrderBy', orderBy);

      dispatch(
        usersActions.getUsersRequest({
          orderBy: orderBy || '',
          search: search || '',
          offset: offset || '',
          direction: dir ? 'asc' : 'desc',
        })
      );

      if (!offset) {
        setPageCurrent(1);
      }
    },
    [dispatch, formik?.values?.search]
  );

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const paginationChange = useCallback(
    async page => {
      setPageCurrent(page);
      const orderBy = sessionStorage.getItem('usersOrderBy');

      const limitOffset = page - 1;
      const offset = page <= 1 ? 0 : limitOffset * limit;

      getUsers({
        offset,
        orderBy: orderBy || '',
        search: formik?.values?.search || '',
        dir: directionAsc,
      });
    },
    [directionAsc, formik?.values?.search]
  );

  const filterUsuarios = async ({ search }) => {
    getUsers({
      search: search || '',
      dir: directionAsc,
    });
  };

  useEffect(() => {
    if (usersSearch && data.length < 1) {
      setNoResults(true);
    }
  }, [data, usersSearch]);

  const saveCSVFile = useCallback(
    response => {
      console.log(response);
      const fileName = response.headers['x-suggested-filename'];
      const BOM = '\uFEFF';
      const csvData = BOM + response.data;
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });

      FileSaver.saveAs(blob, fileName);
    },
    []
  );

  const getDownloadUsuarios = useCallback(async () => {
    setLoadingDownloadUsuarios(true);
    try {
      const result = await api.get(
        `usuarios/download-csv`,
        {
          headers: {
            Authorization: String(token),
          },
        }
      );
      saveCSVFile(result);
    } catch (e) {
      console.log(e);
      const error = e?.response?.data?.fields[0]?.exception;
      toast.error(error || 'Não foi possível concluir sua solicitação', {
        autoClose: 7000,
      });
    } finally {
      setLoadingDownloadUsuarios(false);
    }
  }, [
    saveCSVFile,
    setLoadingDownloadUsuarios
  ]);

  return (
    <>
      <Breadcumbs path="usuarios-do-sistema" pathTitle="Usuários do sistema" />
      <BreadcumbsContainer>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
      </BreadcumbsContainer>
      <PageTitle>
        <div className="headerInline">
          <div>
            <span>Usuários do sistema</span>
          </div>
          <div className="boxSearch">
            <form onSubmit={formik.handleSubmit} method="post">
              <label htmlFor="search">
                <MdSearch size={18} color="#619b30" />
                <input
                  name="search"
                  id="search"
                  placeholder="Buscar usuário"
                  value={formik.values.search}
                  onChange={formik.handleChange}
                />
              </label>{' '}
              <ButtonBase type="submit">Buscar</ButtonBase>
              <ButtonBase
                variant="secondary"
                style={{ marginLeft: 10 }}
                onClick={() => {
                  setSearchBy(null);
                  formik.setFieldValue('search', '');
                  getUsers({ search: null, orderBy: null });
                }}
              >
                Limpar
              </ButtonBase>
            </form>
          </div>
        </div>

        <div>
          <Link to="/administrador/novo-usuario">
            <ButtonBase>
              <>
                <GoPlus />&nbsp; Adicionar novo usuário
              </>
            </ButtonBase>
          </Link>
        </div>
        
        {ROLE_ADMIN  && 
          <div className="boxButtonSave">
            <ButtonBase 
              onClick={getDownloadUsuarios} 
              disabled={loadingDownloadUsuarios}>
                
              <GoDesktopDownload />&nbsp; {!loadingDownloadUsuarios ? 'Download usuários' : 'Realizando download...'}
            </ButtonBase>
          </div>
        }
      </PageTitle>

      {!loading && data.length < 1 ? (
        <BoxContent>
          {noResults && (
            <NoResults>
              <MdErrorOutline size="40" color="#666" />
              <br />
              <p>
                Nenhum resultado encontrado, tente com outros termos <br />
                ou limpe a busca.
              </p>
            </NoResults>
          )}
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      ) : (
        <BoxContent>
          <BoxContentHeader>
            <div>
              <ButtonOrderBy
                isActive={usersOrderBy === 'nome'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getUsers({ orderBy: 'nome', dir: !directionAsc });
                }}
              >
                <span className="usuarioHeader">
                  Usuário{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
            <div>
              <ButtonOrderBy
                isActive={usersOrderBy === 'nomeInstituicao'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getUsers({
                    orderBy: 'nomeInstituicao',
                    dir: !directionAsc,
                    search: searchBy || '',
                  });
                }}
              >
                <span className="instituicaoHeader">
                  Instituição{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
            <div>
              <ButtonOrderBy
                isActive={usersOrderBy === 'permissao'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getUsers({
                    orderBy: 'permissao',
                    dir: !directionAsc,
                    search: searchBy || '',
                  });
                }}
              >
                <span className="permissaoHeader">
                  Permissão{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
            <div>
              <ButtonOrderBy
                isActive={usersOrderBy === 'ativo'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getUsers({
                    orderBy: 'ativo',
                    dir: !directionAsc,
                    search: searchBy || '',
                  });
                }}
              >
                <span className="statusHeader">
                  Status{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
            <div>
              <ButtonOrderBy
                isActive={usersOrderBy === 'dataCriacao'}
                onClick={() => {
                  setDirectionAsc(!directionAsc);
                  getUsers({
                    orderBy: 'dataCriacao',
                    dir: !directionAsc,
                    search: searchBy || '',
                  });
                }}
              >
                <span className="dataCriacaoHeader">
                  Data da criação{' '}
                  {directionAsc ? (
                    <MdArrowDropDown size={20} />
                  ) : (
                    <MdArrowDropUp size={20} />
                  )}
                </span>
              </ButtonOrderBy>
            </div>
          </BoxContentHeader>

          {data.map(
            ({
              id,
              nome,
              nomeInstituicao,
              permissao,
              ativo,
              dataCriacao,
              bloqueado,
            }) => {
              const linkEditar = `/administrador/editar-usuario/${id}`;

              return (
                <BoxList key={id} ativo={ativo} bloqueado={bloqueado}>
                  <div className="usuario">
                    <span>{bloqueado && <IoIosLock size={25} />}</span>
                    <span>{nome}</span>
                  </div>
                  <div className="instituicao">
                    <span>{nomeInstituicao}</span>
                  </div>
                  <div className="permissao">
                    <span>
                      {(permissao === 'ROLE_ADMIN' && 'Administrador') ||
                        (permissao === 'ROLE_USER' && 'Operador') ||
                        (permissao === 'ROLE_MANAGER' && 'Gestor')}
                    </span>
                  </div>
                  <div className="status">
                    <span>{ativo ? 'Ativo' : 'Inativo'}</span>
                  </div>
                  <div className="dataCriacao">
                    <span>
                      {format(new Date(`${dataCriacao}`), 'dd/MM/yyyy - k:mm', {
                        locale: ptBR,
                      })}
                    </span>
                  </div>
                  <div className="buttons">
                    <button type="button">
                      <Link to={linkEditar}>
                        <MdModeEdit size={18} />
                        <span>Editar</span>
                      </Link>
                    </button>
                  </div>
                </BoxList>
              );
            }
          )}

          {data.length > 0 && (
            <BoxPagination>
              <Pagination
                current={pageCurrent}
                pageSize={limit}
                onChange={paginationChange}
                total={Number(totalCount)}
                itemRender={paginationRender}
              />
            </BoxPagination>
          )}
        </BoxContent>
      )}
    </>
  );
};

const paginationRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return (
      <a className="arrowLeft">
        <MdKeyboardArrowLeft size={25} /> Anterior
      </a>
    );
  }
  if (type === 'next') {
    return (
      <a className="arrowRight">
        Próximo <MdKeyboardArrowRight size={25} />
      </a>
    );
  }
  return originalElement;
};

export default UsuariosDoSistema;
